import React from 'react';
import PropTypes from 'prop-types';

// Modules
import CompanyProfileFeaturedSiteCriteria from './CompanyProfileFeaturedSiteCriteria';
import CompanyProfileFeaturedServices from './CompanyProfileFeaturedServices';

// Helpers
import { getCompanyDisplayType } from '@general/helpers/company.helpers';

// Hooks
import useCompanyFull from '@hooks/useCompanyFull';

const CompanyProfileFeaturedSection = ({ graphID }) => {
    const { data: companyData } = useCompanyFull(graphID);

    if (!companyData) {
        return null;
    }

    const { primaryBusinessType } = companyData;
    const companyDisplayType = getCompanyDisplayType(primaryBusinessType);

    switch (companyDisplayType) {
        case 'Broker':
        case 'RetailerTenant':
            return <CompanyProfileFeaturedSiteCriteria graphID={graphID} />;
        case 'ServiceProduct':
        case 'OwnerDeveloper':
            return <CompanyProfileFeaturedServices graphID={graphID} />;

        default:
            return null;
    }
};

CompanyProfileFeaturedSection.propTypes = {
    graphID: PropTypes.string,
};

export default CompanyProfileFeaturedSection;
